import { styled } from '@mui/material/styles';
import { Box } from '../../atoms/Box';
import { Typography } from '../../atoms/Typography';

export const ContentWrapperBox = styled(Box)((props: { borderColor?: string }) =>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 900px;
    width: 80%;
    border: 1px solid #000;
    background-color: white;
    border-radius: 10px;
    padding: 25px;
    border-color: ${props.borderColor ? props.borderColor : 'black'};
  };`
);

export const HeadingWrapper = styled(Typography)`
  padding-bottom: 20px;
`;